var map = {
	"./site-logo-desktop-alt.svg": 83979,
	"./site-logo-desktop-footer.svg": 44383,
	"./site-logo-desktop.svg": 95465,
	"./site-logo-drawer-mobile.svg": 83643,
	"./site-logo-drawer.svg": 76632,
	"./site-logo-mobile-drawer.svg": 17573,
	"./site-logo-mobile.svg": 43533,
	"./site-logo-sm.svg": 43791,
	"./site-logo-wrapper-mobile-scrolled.svg": 47968,
	"./site-logo-wrapper-mobile.svg": 88623,
	"./site-logo-wrapper-scrolled.svg": 41833,
	"./site-logo-wrapper.svg": 10588
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40905;